import React from 'react';
import { OptionTypeBase, Select as MuiSelect } from '@beeline.com/bp-design-system';

interface SelectProps {
  className?: string;
  clearable?: boolean;
  name?: string;
  onChange(value: OptionTypeBase | null): void;
  open?: boolean;
  options: OptionTypeBase[] | readonly OptionTypeBase[];
  placeholder?: string;
  style?: React.CSSProperties;
  value: OptionTypeBase | null | undefined;
  sort?: boolean;
}

export const Select = ({
  className,
  clearable,
  name,
  onChange,
  open,
  options,
  placeholder,
  style,
  value,
  sort
}: SelectProps) => (
  <MuiSelect
    autoComplete
    className={className}
    disableClearable={!clearable}
    dataTest={`select-field${name ? `-${name}` : ''}`}
    id={name ? `select-field-${name}` : undefined}
    name={name}
    menuProps={{
      hideSelectedOptions: false,
      openOnStart: open,
      sort: sort ?? true
    }}
    listBoxProps={{ scrollSelectedItemIntoView: true }}
    onOptionChange={(value) => onChange(value ?? null)}
    options={options as OptionTypeBase[]}
    placeholder={placeholder}
    style={style}
    valueOptions={value ?? undefined}
  />
);
